import { useEffect, useMemo } from 'react'
import Box from '@mui/material/Box'
import queryString from 'query-string'
import useAuthActions from 'store/actions/auth'
import { useAuth } from 'store/selectors'
import { AUTH_URL } from 'const'

const Auth = () => {
  const { getUser } = useAuthActions()
  const { loggedOut, error } = useAuth()

  useEffect(() => {
    const handleEvent = (event) => {
      // Tokens are taken from the sign-in page only: they are kept on this
      // device, so one posted by another window would stay signed in.
      if (event.origin !== new URL(AUTH_URL).origin) return
      if (!event.data?.access_token) return

      // The code field had the focus inside the iframe; a phone's keyboard
      // would otherwise stay up over the page that replaces it.
      document.activeElement?.blur()
      getUser({
        token: event.data.access_token,
        refreshToken: event.data.refresh_token,
        authUser: JSON.parse(atob(event.data.user)),
      })
    }

    window.addEventListener('message', handleEvent)
    return () => window.removeEventListener('message', handleEvent)
  }, [getUser])

  // A refusal signs the iframe out. Any other failure leaves it signed in but
  // without auto_redirect, so it shows the error and continue as, rather
  // than handing the same token straight back to fail again.
  const iframeSrc = useMemo(() => {
    const params = loggedOut
      ? { logout_on_load: 1 }
      : error
      ? {}
      : { auto_redirect: 1 }

    if (error) params.error = error

    return `${AUTH_URL}?${queryString.stringify(params)}`
  }, [loggedOut, error])

  return (
    <Box
      sx={{
        height: '100dvh',
        '& > iframe': {
          width: '100%',
          height: '100%',
          border: 0,
        },
      }}
    >
      <iframe src={iframeSrc} title="auth" />
    </Box>
  )
}

export default Auth
